/**
 * Second-pass cleanup after the Vue bundle loads. The inline blade script runs
 * first; this catches anything missed without registering a service worker.
 */

const CLEANUP_VERSION = '20260703'
const STORAGE_KEY = 'pineapple_legacy_cache_cleared'

export async function purgeLegacyWebCaches(): Promise<void> {
    if (process.env.VUE_APP_WEB_BUILD !== 'yes') {
        return
    }

    try {
        if (sessionStorage.getItem(STORAGE_KEY) === CLEANUP_VERSION) {
            return
        }
    } catch {
        // sessionStorage unavailable — still attempt cleanup once.
    }

    let hadServiceWorker = false

    try {
        if ('serviceWorker' in navigator) {
            const registrations = await navigator.serviceWorker.getRegistrations()
            if (registrations.length) {
                hadServiceWorker = true
            }
            await Promise.all(registrations.map((registration) => registration.unregister()))
        }

        if (window.caches) {
            const keys = await caches.keys()
            await Promise.all(keys.map((key) => caches.delete(key)))
        }
    } catch {
        // Best-effort cleanup only.
    }

    try {
        sessionStorage.setItem(STORAGE_KEY, CLEANUP_VERSION)
    } catch {
        // ignore
    }

    if (hadServiceWorker) {
        window.location.reload()
    }
}
